import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import materiaPrima from '../materiaPrima/materiaPrima';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PRODUCAO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'PRODUCAO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function setFiltro(filtro) {
    return {
        type: 'PRODUCAO_SET_FILTRO',
        payload: filtro
    };
}

export function initForm(registro = {}) {
    return [
        initialize('producaoForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/producao?data_agendamento=${getState().producao.filtro.data || '9999/01/01'}`)
		.then(resp => {
			dispatch({
		        type: 'PRODUCAO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaSolicitacoes() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/solicitacao?sem_producao=true`)
		.then(resp => {
			dispatch({
		        type: 'PRODUCAO_SOLICITACAO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/producao`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/producao`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function fecharDia(lista) {
    return async (dispatch, getState) => {

		dispatch(setAguardando(true));

		for (let i = 0; i < lista.length; i++) {
			const registro = lista[i];
			
			await axios.put(`${consts.API_URL}/producao`, {
				...registro,
				datahora_confirmacao: DateFormat.getDataHoraAtual(),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {
				
			}).catch(e => {
				setErroAPI(e);
			});
		}

		dispatch(setAguardando(false));
		setSuccess('Operação Realizada com sucesso.');
		dispatch(getLista());
    };
}

export function reabrirDia(lista) {
    return async (dispatch, getState) => {

		dispatch(setAguardando(true));

		for (let i = 0; i < lista.length; i++) {
			const registro = lista[i];
			
			await axios.put(`${consts.API_URL}/producao`, {
				...registro,
				datahora_confirmacao: null,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {
				
			}).catch(e => {
				setErroAPI(e);
			});
		}

		dispatch(setAguardando(false));
		setSuccess('Operação Realizada com sucesso.');
		dispatch(getLista());
    };
}

export function alterarOrdem(registros) {
    return async (dispatch, getState) => {

		dispatch(setAguardando(true));

		for (let i = 0; i < registros.length; i++) {
			const registro = registros[i];
			
			await axios.put(`${consts.API_URL}/producao`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {
				
			}).catch(e => {
				setErroAPI(e);
			});
		}

		dispatch(setAguardando(false));
		dispatch(getLista());

	};
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/producao?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaTipo() {
    const request = axios.get(`${consts.API_URL}/producaoTipo`);
    return {
        type: 'PRODUCAO_TIPO_SELECT_LISTADO',
        payload: request
    };
}

export function gerarPdfSintetico(lista) {

	return (dispatch, getState) => {
		
		dispatch(setAguardando(true));

		axios.post(`${consts.API_URL}/producao/gerarPdfSintetico`, {
			datahora_emissao: DateFormat.getDataHoraAtual(),
			nome_usuario_emissao: getState().auth.usuario.nome,
	            lista: lista.map(registro => ({
					...registro,
					data_agendamento: DateFormat.formatarDataSqlParaTela(registro.data_agendamento),
					data_carga: DateFormat.formatarDataSqlParaTela(registro.data_carga),
					quantidade: Number(FormatUtils.formatarValorTela(registro.quantidade, 0)).toLocaleString('pt-BR')
			}))
        }).then(resp => {
			
			const link = document.createElement('a');
			link.href = `data:application/pdf;base64,${resp.data.pdf}`;
			link.download = resp.data.filename;
			link.click();

			dispatch(setAguardando(false));
		}).catch(ex => {
			console.log(ex);
			dispatch(setAguardando(false));
		});

	}
}

export function gerarPdf(lista) {

	return (dispatch, getState) => {
		
		dispatch(setAguardando(true));

		axios.post(`${consts.API_URL}/producao/gerarPdf`, {
			datahora_emissao: DateFormat.getDataHoraAtual(),
			nome_usuario_emissao: getState().auth.usuario.nome,
	            lista: lista.map(registro => ({
					...registro,
					data_agendamento: DateFormat.formatarDataSqlParaTela(registro.data_agendamento),
					data_carga: DateFormat.formatarDataSqlParaTela(registro.data_carga),
					quantidade: FormatUtils.formatarValorTela(registro.quantidade, 2),
				itens: (registro.itens || []).map(item => ({
					...item,
					quantidade: FormatUtils.formatarValorTela(item.quantidade, 2),
					materias_primas: (item.materias_primas || []).map(materiaPrima => ({
						...materiaPrima,
						quantidade: FormatUtils.formatarValorTela(materiaPrima.quantidade, 2),
					}))
				}))

			}))
        }).then(resp => {
			
			const link = document.createElement('a');
			link.href = `data:application/pdf;base64,${resp.data.pdf}`;
			link.download = resp.data.filename;
			link.click();

			dispatch(setAguardando(false));
		}).catch(ex => {
			console.log(ex);
			dispatch(setAguardando(false));
		});

	}
}
